import axios from 'axios';
import { settings } from '../settings';

const AxiosClient = axios.create({
  baseURL: settings.ConfiguratorEndpoint,
  timeout: 60000,
  withCredentials: false,
});

export default AxiosClient;
